import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCircle, faBell } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { openProfileModal } from "../../store/common/profileModalSlice";
import { getNotificationFun, userLogout } from "../../thunks/dashboardThunks";
import { useNavigate } from "react-router-dom";
import "./topbar.css";

const TopBar = () => {
  const { trial } = useSelector((state) => state?.user);
  const { notificationData } = useSelector((state) => state?.templates);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [notification, setNotification] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [tickerText, setTickerText] = useState("");
  const ref = useRef(null);
  const notificationRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setNotification(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    dispatch(getNotificationFun());
  }, [dispatch]);

  useEffect(() => {
    fetch("https://dev.vidboard.ai/tool/get_ticker_text/")
      .then(response => response.json())
      .then(data => {
        if (data.data && data.data.length > 0) {
          setTickerText(data.data[0].text);
        }
      })
      .catch(error => console.error("Error fetching ticker text:", error));
  }, []);

  const handleOpenModal = () => {
    toggleDropdown();
    dispatch(openProfileModal());
  };

  const handleLogout = () => {
    const callback = () => (window.location.href = "/");
    return dispatch(userLogout(callback));
  };

  const handleNotification = () => {
    setNotification(!notification);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const currentUrl = window.location.pathname;

  return (
    <div className="flex justify-between items-center p-4">
      {/* Upgrade Button */}
      {isVisible && (
        <div
          className={`overflow-hidden border-2 p-1 mr-4 rounded-3xl bg-white ${
            currentUrl === "/video" ? "w-[100%]" : "w-[65%]"
          } boxAnimation `}
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <img
                width={25}
                height={25}
                src="/tool/dashboard/static/images/microMarqu.png"
                className="flex-shrink-0"
              />
              <div
                className={`mx-4 text-sm whitespace-break-spaces ${
                  currentUrl === "/video" ? "flex" : ""
                }`}
              >
                {currentUrl !== "/video" ? (
                  <b>{tickerText}</b>
                ) : (
                  <>
                    <p className="text-xs">
                      <b>
                        Your video will be available within a few minutes.
                        Please be patient.{" "}
                      </b>
                      If you do not receive the video within a few hours, then
                      please email us at admin@vidboard.ai and we will be happy
                      to assist you.
                    </p>
                  </>
                )}
              </div>
            </div>
            <button
              onClick={() => setIsVisible(false)}
              className="text-xs text-gray-300 mr-4"
            >
              &#10005;
            </button>
          </div>
        </div>
      )}

      <div className="flex-grow"></div>

      <div className="flex items-center flex-shrink-0">
        <div className="relative" ref={notificationRef}>
          <div className="relative cursor-pointer" onClick={handleNotification}>
            <FontAwesomeIcon
              icon={faBell}
              className="text-gray-700 mr-4"
            />
            <span
              className="absolute top-0 right-0 h-2 w-2 animate-ping bg-red-500 rounded-full"
              style={{ width: "8px", height: "8px", top: "2px", right: "14px" }}
            ></span>
          </div>
          {notification && (
            <div
              className="absolute right-0 mt-2 w-[500px] h-[550px] overflow-y-auto bg-white border border-gray-300 rounded-md shadow-lg"
              style={{ zIndex: 1, overflowX: "hidden" }}
            >
              <div className="p-4" style={{ maxWidth: "580px" }}>
                <h1 className="mb-2 text-black text-lg font-bold mb-4">
                  Notifications
                </h1>
                {notificationData.map((item, index) => {
                  const [beforeColon, afterColon] = item.value.split(":");
                  return (
                    <div
                      key={index}
                      className="mb-6 flex flex-row items-center overflow-x-hidden"
                      style={{ overflowWrap: "break-word" }}
                    >
                      <span className="bullet mb-10 ">&#8226;</span>
                      <div className="ml-2 overflow-hidden">
                        <h1 className="font-bold">{beforeColon}</h1>
                        <h2
                          style={{ lineHeight: "1.5" }}
                          className="text-gray-700"
                        >
                          {afterColon}
                        </h2>
                        <p className="border-[1px] w-[500px] mt-4"></p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>

        <div className="relative" ref={ref}>
          <FontAwesomeIcon
            icon={faUserCircle}
            className="text-gray-700 cursor-pointer"
            onClick={toggleDropdown}
          />
          {isDropdownOpen && (
            <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-300 rounded-md shadow-lg">
              <div
                className="p-4 hover:bg-gray-200 hover:text-gray-800 cursor-pointer"
                onClick={handleOpenModal}
              >
                Profile
              </div>
              <div
                className="p-4 hover:bg-gray-200 hover:text-gray-800 cursor-pointer"
                onClick={handleLogout}
              >
                Logout
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TopBar;
